import { useFormatDate } from '../../../DateRangePicker/useFormatDate';

export const DateRangeLabel = ({ chipDefaultValue, value }) => {
  const { getFormattedDate } = useFormatDate();

  if (!value || value?.length === 0 || (!value[0] && !value[1])) {
    return chipDefaultValue;
  } else {
    return getFormattedDate(value[0], value[1]);
  }
};
